import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { push } from 'react-router-redux';

import { tryToUpdateTeamName, tryToFetchMyTeams  } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'
import Tabs from '../Tabs/Tabs.js'
import CustomField from '../CustomField/CustomField.js'


class TeamSettingsNameForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    var t = props.team.cache[props.team.current] || {};

    this.state = {
      display_name: props.team.updateTeamNameForm.lastSubmit.display_name || t.display_name
    }

    this.handleUpdateTeamName = this.handleUpdateTeamName.bind(this);
  }

  componentWillMount(){
    const { dispatch, team, id } = this.props;

    if(!team.cache[id] || new Date().getTime() - team.cache[id].lastFetch < 2000){
      dispatch(tryToFetchMyTeams());
    }
  }

  componentWillReceiveProps(newprops){
    var t = newprops.team.cache[newprops.id];

    if(this.state.display_name == undefined){
      this.setState({
        display_name: newprops.team.updateTeamNameForm.lastSubmit.display_name || t.display_name
      })
    }
  }


  handleUpdateTeamName(e){
    if(e) e.preventDefault();

    const { dispatch, team } = this.props;

    var t = team.cache[this.props.id];

    dispatch(tryToUpdateTeamName({
      id: this.props.id,
      display_name: this.state.display_name
    }))

  }

  render(){
    const { dispatch, team, user, change } = this.props; 
    const state = this.state;

    var t = team.cache[this.props.id];

    if(!t) return <i className="fal fa-spinner-third fa-spin fa-2x"/>

    var myRole = 'member';
    for(var i in t.members){
      if(t.members[i].id === user.id){
        myRole = t.members[i].role;
      }
    }


    return (
      <div>
        <form onSubmit={this.handleUpdateTeamName}>
          <CustomField 
            type="text"
            name="display_name"
            placeholder="What's the name of your firm?"
            label="Firm Name"
            onChange={(v) => { console.log(v); this.setState({display_name: v}); }}
            serverErrors={team.updateTeamNameForm.errors.display_name}
            required={true}
            maxLength={64}
            disabled={team.tryingToUpdateTeamName}
          />

          <div className="list-right">
            <Button 
              submit={true} 
              size="medium" 
              disabled={!state.display_name || state.display_name == t.display_name} 
              thinking={team.tryingToUpdateTeamName} 
              successful={team.successfullyUpdatedTeamName}
              failed={team.failedToUpdatedTeamName}
              color="success" 
              display="Save Changes" 
            />
          </div>
        </form>
      </div>
    )
  }
}


TeamSettingsNameForm = reduxForm({
  form: 'TeamSettingsNameForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(TeamSettingsNameForm)

TeamSettingsNameForm = connect((state, ownProps) => {
  const { team, user } = state;

  var t =  team.cache[ownProps.id];

  var initialValues = {
    display_name: t ? t.display_name : ''
  };
  
  return {
    team,
    user,
    initialValues
  }
})(TeamSettingsNameForm);

export default TeamSettingsNameForm;


// WEBPACK FOOTER //
// ./src/components/TeamSettingsNameForm/TeamSettingsNameForm.js